import { locationIdFormat } from "@redotech/redo-inventory-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const toggleLocationReturnsCenter = unaryRpc({
  name: "toggleLocationReturnsCenter" as const,
  input: z.object({
    teamId: z.string(),
    locationId: locationIdFormat.schema,
    isReturnsCenter: z.boolean(),
  }),
  output: z.object({
    success: z.boolean(),
    validationWarning: z.string().optional(),
    proposedAddress: z
      .object({
        street1: z.string(),
        street2: z.string().optional(),
        city: z.string(),
        state: z.string().optional(),
        postalCode: z.string(),
        country: z.string(),
      })
      .optional(),
  }),
});
